const createAccount = () => 'create account';

export default createAccount;
